<template>
    <router-link :to="detailRoute"
        class="block no-underline text-inherit cursor-pointer p-3 my-2 rounded-lg border-1 transition-all hover:shadow-md border-gray-300 hover:border-customBlue-100 bg-white ">
        <div class="flex flex-col gap-1">
            <div class="flex items-center justify-between gap-2 mb-1">
                <div>
                    <p class="m-0 font-roboto text-[14px] leading-[20px] font-normal text-[#EA8A8A]">
                        {{ !item.created_at ? '-' : $helper.formatDateTime(item.created_at) }}
                    </p>
                </div>
                <span v-if="!isBlank(item.status?.consumer?.text)" :style="{ backgroundColor: getStatusClass(item.status.consumer.text) }"
                    class="text-white rounded-md px-2 py-[2px] capitalize block w-fit flex-shrink-0 whitespace-nowrap font-roboto text-[12px] leading-[16px] font-normal">
                    {{ formatStatus(item.status.consumer.text) }}
                </span>
            </div>

            <div class="flex items-center justify-between gap-2">
                <div>
                    <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Quote ID:</span>
                    <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                        {{ show(item.id) }}
                    </p>
                </div>
                <img v-if="partnerLogo(item)" :src="partnerLogo(item)" :alt="item.partner_info.company_name || 'Partner'"
                    class="w-12 h-10 object-contain flex-shrink-0" @error="$event.target.style.display = 'none'">
            </div>
            <div>
                <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Consumer Name:</span>
                <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                    {{ show(item.consumer?.full_name) }}
                </p>
            </div>
            <div>
                <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Job Type:</span>
                <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                    {{ show(item.job?.title) }}
                </p>
            </div>
            <div class="grid grid-cols-5">
                <div class="col-span-3">
                    <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Source:</span>
                    <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                        {{ isBlank(item.job_source?.title) ? '-' : item.job_source.title + ' - ' + item.job_source.id }}
                    </p>
                </div>
                <div class="col-span-2">
                    <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Amount:</span>
                    <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                        {{ amount(item) }}
                    </p>
                </div>
            </div>
        </div>
    </router-link>
</template>
<script>

export default {
    components: {
    },
    props: ["item"],
    data() {
        return {
            isOpen: false,
            user: JSON.parse(localStorage.getItem("user")) ?? null
        };
    },
    computed: {
        detailRoute() {
            return { name: "QuoteDetail", params: { id: this.item.id } };
        },
    },
    mounted() {
    },
    unmounted() {
    },
    methods: {
        // partner (NRG / DEPP) quote: partner_info.status with the company logo (Android IndependentQuoteListingAdapter)
        partnerLogo(item) {
            const p = item.partner_info;
            return p && [1, "1", true].includes(p.status) && p.company_logo ? p.company_logo : null;
        },
        // no amount yet: $0.00, not "-"
        amount(item) {
            return this.$helper.isEmpty(item.selected_payment?.amount_prefix) ? "$0.00" : item.selected_payment.amount_prefix;
        },
        isBlank(value) {
            return value === null || value === undefined || String(value).trim() === '';
        },
        // Empty cells show "-"
        show(value) {
            return this.isBlank(value) ? '-' : value;
        },
        getStatusClass(status) {
            const statusClasses = {
                'Started': '#00BCD4',
                'Installation Started': '#65B741',
                'Pending Checkout': '#429538',
                'Pending': '#F59E0B',
                'Pending Approval': '#8B5E3C',
                'Suspended': '#DC2626',
                'Payment Completed': '#65B741',
                'Completed': '#10B981',
                'Order Closed': '#686D76',
                'Scheduled': '#0284C7',
                'Cancelled': '#B91C1C',
            };
            return statusClasses[status] || '#6B7280'; // inline style needs a colour, not a class (was 'bg-gray-500' → invisible badge)
        },
        formatStatus(status) {
            return status
                ?.toLowerCase()
                .replace(/\b\w/g, char => char.toUpperCase());
        }
    }
};
</script>